<template>
  <div class="ack workspace-grid workspace">
    <div class="list">
      <h1>Privacy Policy</h1>

        <h2>Data Processed</h2>
        <p>
          When you interact with us through this website, we collect the
          following information:
        </p>
        <ul>
          <li>IP address</li>
          <li>browser</li>
          <li>which jobs you calculated</li>
          <li>date and time of website visit</li>
          <li>type of your operating system</li>
          <li>(optionally) e-mail address if provided during job submission</li>
        </ul>
        <h2>Data Controller</h2>
        <p>
          The controller of the above listed data is Loschmidt Laboratories,
          Department of Experimental Biology and RECETOX, Faculty of Science,
          Masaryk University, Kotlarska 267/2, 611 37 Brno, Czech Republic
          (further in this text referred to as "LL").
        </p>
        <h2>Reason for Personal Data Processing</h2>
        <p>
          Personal data relating to usage of the website (traffic and location)
          are being processed for the purpose of:
        </p>
        <ul>
          <li>statistics</li>
          <li>service monitoring</li>
          <li>optimisation of partial tasks</li>
          <li>notification of job status</li>
          <li>security</li>
          <li>
            drafting annual reports, monitoring reports, project result
            summaries and other similar documents for the purpose-built support
            providers
          </li>
        </ul>
        <h2>Third Party Disclosure</h2>
        <p>
          We do not disclose any data about our website users to third parties.
        </p>
        <h2>Data Retention</h2>
        <p>
          Personal data are stored for the period set by individual providers of
          purpose-built support provided to LL, with the minimum period of 5
          years after the projects had been terminated.
        </p>
        <p>
          If you do not wish LL to process your data related to this website
          usage, please do not visit this internet page.
        </p>

      </div>
    <RightInfoPanel />
  </div>
</template>

<script>

import RightInfoPanel from "../components/RightInfoPanel";

export default {
  components: {
    RightInfoPanel,
  },

  methods: {
 
  },
};

</script>

<style scoped>
.ack {
  text-align: left;
  padding-bottom: 1vh;
  /*margin: 5vh;*/
  /*font-weight: bold;*/
}

.dakrlist {
  text-align: left;
  background: #cecece;
  padding-top: 1vh;
  padding-bottom: 1vh;
}

.list {
  /* padding-left: 15vh; */
  padding-right: 3vh;
}

@media (min-width: 950px) {
  .workspace-grid {
    display: grid;
    grid-template-columns: auto 340px;
  }
}  

</style>
